import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ApplicationList } from '../../../communication-structure/application-list';
import { AutoTrainingCodeModel } from '../../../communication-structure/auto-training-code-model';
import { CandidateModel } from '../../../communication-structure/new-candidate-model';
import { SendEmailModel } from '../../../communication-structure/send-email-model';
import { CommunicationProxyService } from '../../../services/communication-proxy.service';
import { CsvHelperService } from '../../../services/csv-helper-service.service';
import { LoginService } from '../../../services/login.service';
import { StringTableService } from '../../../services/string-table.service';
import { dialogTypeEnum } from '../../modal-dialog/modal-dialog.component';
import { PageViewComponent } from '../../page-view/page-view.component';
import { Table, TableComponent, Types } from '../../table/table.component';
import { TextareaComponent } from '../../textarea/textarea.component';
import { TextboxComponent } from '../../textbox/textbox.component';
import { ButtonModel } from '../../tg-button/tg-button.component';
import { activeTrainingPageEnum, TrainingManagementComponent } from './../training-management/training-management.component';

@Component({
  selector: 'app-email-invite',
  templateUrl: './email-invite.component.html',
  styleUrls: ['./email-invite.component.scss']
})
export class EmailInviteComponent extends PageViewComponent implements OnInit {

  @Output() onCancelButtonClicked = new EventEmitter<number>();
  @Output('reloadActivePage') reloadActivePage = new EventEmitter<number>();
  @ViewChild('FirstNameEdit') firstName;
  @ViewChild('LastNameEdit') lastName: TextboxComponent;
  @ViewChild('EmailEdit') emailEdit;
  @ViewChild('EmailTextEdit') emailBody: TextareaComponent;
  @ViewChild('SelectTraining') selectTrainingDropdown;
  @ViewChild('importCsv') importCsvInput;


  public dialogType = dialogTypeEnum.default;
  public pageTitle: string;
  public pageDesc: string;
  public dropdownTitle: string;
  trainingData: Array<AutoTrainingCodeModel>;
  dropdownData: Array<{ id: string, name: string }>;
  public emailEntryTitle: string;
  public emailTextKeywordsTitle: string;
  public emailTextKeywordsText: string;
  public fnameTitle: string;
  public lnameTitle: string;
  public emailTitle: string;
  public emailListTitle: string;
  public editEmailTitle: string;
  public textareaPlaceholder: string;
  public emailAddedTitle: string;
  public emailAddedDesc: string;
  public getClientATCList: string;
  public emailSentTitle: string;
  public emailSentDesc: string;
  public noDataText: string;
  public noAddedEmail: string;
  public getAllApplicationWithScoreForAtc: string;
  public getFailedEmailsEndPoint: string;
  emailListIndex = 0;
  emailsFailed: CandidateModel[] = [];
  emailsFailedCount = 0;
  emailsSent = 0;
  failed: number = 0;
  totalItems: number = 0;
  emailList: CandidateModel[] = [];
  atc: any;
  responseCounter: number;
  testSessionLink: string;
  emailText: string;
  table: Table[][] = [];
  header: Table[];

  isExtendedTable: boolean;
  atcSelected: string = null;
  candidateList: Array<CandidateModel> = [];
  sendMailToApplicationsEndPoint: string;
  candidateIndex = 0;
  public emailAlreadyExists: string;

  public addEmailData: ButtonModel = { name: '', icon: '' };
  public importEmailData: ButtonModel = { name: '', icon: '' };
  public importTemplateData: ButtonModel = { name: '', icon: '' };
  public cancelData: ButtonModel = { name: '', icon: '' };
  public sendData: ButtonModel = { name: '', icon: '' };
  currentEmail: string;


  constructor(ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router,
    protected cdr: ChangeDetectorRef,
    protected csvHelper: CsvHelperService) {
    super(ele, remoteProxy, loginService, stringTableService, router);
  }

  ngOnInit() {
    TrainingManagementComponent.setActiveTrainingPage(activeTrainingPageEnum.emailInvite);
    this.retrieveStrings();
    this.createHeader();
    this.getClientAtcList(ATCTYPE.ACTIVE);
    this.selectTrainingDropdown.setFocus();
  }

  retrieveStrings() {
    this.pageTitle = this.stringTableService.getString('emailInvite', 'pageTitle');
    this.pageDesc = this.stringTableService.getString('emailInvite', 'pageDesc');
    this.dropdownTitle = this.stringTableService.getString('emailInvite', 'dropdownTitle');
    this.emailEntryTitle = this.stringTableService.getString('emailInvite', 'emailEntryTitle');
    this.fnameTitle = this.stringTableService.getString('labels', 'firstName');
    this.lnameTitle = this.stringTableService.getString('labels', 'lastName');
    this.emailTitle = this.stringTableService.getString('labels', 'email');
    this.emailListTitle = this.stringTableService.getString('emailInvite', 'emailListTitle');
    this.editEmailTitle = this.stringTableService.getString('emailInvite', 'editEmailTitle');
    this.emailTextKeywordsTitle = this.stringTableService.getString('emailInvite', 'emailTextKeywordsTitle');
    this.emailTextKeywordsText = this.stringTableService.getString('emailInvite', 'emailTextKeywordsText');
    this.textareaPlaceholder = this.stringTableService.getString('emailInvite', 'textareaPlaceholder');
    this.emailAddedTitle = this.stringTableService.getString('emailInvite', 'emailAddedTitle');
    this.emailAddedDesc = this.stringTableService.getString('emailInvite', 'emailAddedDesc');
    this.emailSentTitle = this.stringTableService.getString('emailInvite', 'emailSentTitle');
    this.emailSentDesc = this.stringTableService.getString('emailInvite', 'emailSentDesc');
    this.noDataText = this.stringTableService.getString('emailsSent', 'noData');
    this.noAddedEmail = this.stringTableService.getString('emailInvite', 'noEmails');
    this.getClientATCList = this.stringTableService.getEndpoint('GetClientATCList');
    this.getAllApplicationWithScoreForAtc = this.stringTableService.getEndpoint('GetAllApplicationWithScoreForAtc');
    this.sendMailToApplicationsEndPoint = this.stringTableService.getEndpoint('SendMailToApplications');
    this.emailAlreadyExists = this.stringTableService.getString('emailInvite', 'emailAlreadyExists');
    this.getFailedEmailsEndPoint = this.stringTableService.getEndpoint('GetFailedEmails');

    this.addEmailData = {
      name: this.stringTableService.getString('emailInvite', 'addBtnData'),
      icon: this.stringTableService.getString('icons', 'add')
    };

    this.importEmailData = {
      name: this.stringTableService.getString('emailInvite', 'importBtnData'),
      icon: this.stringTableService.getString('icons', 'renamed')
    };

    this.importTemplateData = {
      name: this.stringTableService.getString('emailInvite', 'downloadImportTemplate'),
      icon: this.stringTableService.getString('icons', 'download')
    };

    this.cancelData = {
      name: this.stringTableService.getString('labels', 'cancel'),
      icon: this.stringTableService.getString('icons', 'x')
    };

    this.sendData = {
      name: this.stringTableService.getString('labels', 'send'),
      icon: this.stringTableService.getString('icons', 'check')
    };
  }

  /**
   * go back to home screen on cancel click
   */
  onCancelBtnClicked() {
    this.loadHome();
  }

  /**
   * create table header
   */
  createHeader() {
    this.header = [];
    this.header.push(new Table(Types.TEXT, 'table-header', this.stringTableService.getString('labels', 'firstName')));
    this.header.push(new Table(Types.TEXT, 'table-header', this.stringTableService.getString('labels', 'lastName')));
    this.header.push(new Table(Types.TEXT, 'table-header', this.stringTableService.getString('labels', 'email')));
    this.header.push(new Table(Types.TEXT, 'table-header', ''));
  }

  /**
   *
   * @param activeStatus the type of ATC list which we want to fetch 0 - inactive, 1 - active, 2 - both
   */
  getClientAtcList(activeStatus) {
    this.getDataFromApi(this.getClientATCList, { clientId: this.currentUserClientID, active: activeStatus })
      .subscribe(this.handleClientAtcListData.bind(this),
      this.handleSubscriptionError.bind(this, this.getClientAtcList.bind(this, activeStatus), false));
  }

  /**
   * create table using response
   * @param data response from server
   */
  handleClientAtcListData(data) {
    this.hideLoader();
    this.trainingData = data.autoTrainingCodeList;
    this.dropdownData = [];

    for (const record of this.trainingData) {
      this.dropdownData.push({ id: record.autoTrainingCodeId, name: record.autoTrainingCodeName });
    }
  }

  /**
   *
   * @param data info about the ATC selected in dropdown
   */
  onMenuItemChange(data) {
    this.resetAddedEmails();
    this.atc = data;
    this.emailText = this.stringTableService.getString('emailInvite', 'emailInviteText');
    this.atcSelected = data.id;
    this.cdr.detectChanges();
    this.emailBody.setText(this.emailText);
    this.getDataFromApi(this.getFailedEmailsEndPoint, { atcId: data.id }).subscribe(
      this.getFailedEmailsSuccessHandler.bind(this),
      this.handleSubscriptionError.bind(this, this.onMenuItemChange.bind(this, data), false)
    );
  }

  /**
   * Success handler for get failed emails api call.
   * @param { object } response Object containing response status and list of failed emails for the selected atc.
   */
  getFailedEmailsSuccessHandler(response: { response: string, failedEmails: CandidateModel[] }) {
    this.hideLoader();
    for (const application of response.failedEmails) {
      this.addCandidateInfoToTable(
        application.candidateFirstName,
        application.candidateLastName,
        application.candidateEmail,
        application.applicationId,
        false
      );
    }
    this.emailsFailedCount = response.failedEmails.length;
  }

  
  private addCandidateInfoToTable(firstName: string, lastName: string, email: string, applicationId?: number, isAddedByUser?: boolean) {
    if (!this.checkDuplicateEmail(email.trim())) {
      const candidate: CandidateModel = {
        candidateFirstName: this.handleEmptyField(firstName.trim()),
        candidateLastName: this.handleEmptyField(lastName.trim()),
        candidateEmail: this.handleEmptyField(email.trim()),
        applicationId: applicationId
      };

      this.table.push([
        this.addDataInTableRow(candidate.candidateFirstName.trim(), Types.TEXT),
        this.addDataInTableRow(candidate.candidateLastName.trim(), Types.TEXT),
        this.addDataInTableRow(candidate.candidateEmail.trim(), Types.MAIL_TO),
        new Table(Types.LINK_ICON, 'tg-x', ''),
        this.addDataInTableRow(applicationId, Types.HIDDEN_ID)
      ]);

      this.emailList.push(candidate);
      this.isExtendedTable = this.table.length > 4;
      if (isAddedByUser) {
        this.onEmailAddSuccess();
      } else {
        this.hideLoader();
      }
    }
  }
  onAddEmailClick() {
    this.progressPopup = false;
    if (this.isValidate()) {
      this.candidateList = [];
      this.addCandidateInfoToTable(this.firstName.text, this.lastName.text, this.emailEdit.text);
    }
  }

  fillApplicationList(firstName, lastName, email) {
    if (!this.checkDuplicateEmail(email)) {
      const candidate: CandidateModel = {
        candidateFirstName: this.handleEmptyField(firstName),
        candidateLastName: this.handleEmptyField(lastName),
        candidateEmail: this.handleEmptyField(email),
        applicationId: 0
      };

      this.table.push([
        this.addDataInTableRow(candidate.candidateFirstName.trim(), Types.TEXT),
        this.addDataInTableRow(candidate.candidateLastName.trim(), Types.TEXT),
        this.addDataInTableRow(candidate.candidateEmail.trim(), Types.MAIL_TO),
        new Table(Types.LINK_ICON, 'tg-x', ''),
        this.addDataInTableRow(candidate.applicationId , Types.HIDDEN_ID)
      ]);
      this.cdr.detectChanges();
      this.isExtendedTable = this.table.length > 4;
      this.onEmailAddSuccess();
    }

  }

  checkDuplicateEmail(emailToAdd): boolean {
    let isDuplicate = false;
    for (const row of this.table) {
      if (row[2].title === emailToAdd) {
        this.showValidationPopup(this.emailAlreadyExists, '');
        isDuplicate = true;
        break;
      }
    }
    return isDuplicate;
  }

  handleEmptyField(value) {
    if (value.length === 0 || value == null) {
      value = '-';
    }
    return value;
  }

  onEmailAddSuccess() {
    this.hideLoader();
    this.resetInput();
    this.showValidationPopup(this.emailAddedTitle, this.emailAddedDesc);
  }

  /**
   * Resets all the input boxes.
   */
  public resetInput() {
    event.preventDefault();
    this.firstName.resetTextBox();
    this.lastName.resetTextBox();
    this.emailEdit.resetTextBox();
  }

  onSendBtnClick() {
    this.emailsSent = 0;
    this.emailListIndex = 0;
    this.emailsFailed = [];
    this.failed = 0;
    this.responseCounter = 0;
    this.totalItems = this.table.length;
    if (!this.table.length) {
      this.progressPopup = false;
      this.showValidationPopup(this.noDataText, this.noAddedEmail);
    } else if (this.checkForValidData()) {
      this.sendEmailInvite();
    }

  }

  sendEmailInvite() {
    this.progressPopup = true;
    this.validationPopup = false;
    if (this.progressPopup) {
      this.showDialog({ title: 'Emails Sent', body: '' }, () => {
        this.table = [];
        this.emailListIndex = 0;
        this.emailsSent = 0;
        for (const candidate of this.emailsFailed) {
          this.addCandidateInfoToTable(candidate.candidateFirstName, candidate.candidateLastName, candidate.candidateEmail, null);
        }
        this.emailList = this.emailsFailed;
        this.emailsFailedCount = this.emailsFailed.length;
        this.emailsFailed = [];
        this.importCsvInput.nativeElement.value = '';
      });
      const dataToBeSent: SendEmailModel = {
        clientId: this.currentUserClientID,
        autoTrainingCodeId: this.atcSelected,
        emailText: this.emailBody.text,
        applicantDetails: null
      };

      const self = this;

      const candidateData: CandidateModel = {
        candidateFirstName: this.removeDash(this.table[this.emailListIndex][0].title as string),
        candidateLastName:  this.removeDash(this.table[this.emailListIndex][1].title as string),
        candidateEmail: (this.table[this.emailListIndex][2].title as string),
        applicationId: (this.table[this.emailListIndex][4].title as number)
      };
      dataToBeSent.applicantDetails = candidateData;
      self.postDataToApi(self.sendMailToApplicationsEndPoint, dataToBeSent)
        .subscribe(
          this.onEmailSendSuccess.bind(this),
          this.handleEmailError.bind(this, this.emailList[this.emailListIndex])
        );
    }
    this.currentEmail = (this.table[this.emailListIndex][2].title as string);
  }

  onEmailSendSuccess() {
    this.responseCounter++;
    this.hideLoader();
    this.emailsSent++;
    this.sendNextEmail();
    if (this.responseCounter === this.table.length) {
      this.getDataFromApi(this.getFailedEmailsEndPoint, { atcId: this.atcSelected }).subscribe(
        this.getFailedEmailsSuccessHandler.bind(this),
        this.handleSubscriptionError.bind(this, this.onSendBtnClick.bind(this, this.atc), false)
        );
        this.resetAddedEmails();
    }

  }

  onEmailSendFailure(error) {
    this.responseCounter++;
    this.handleSubscriptionError(this, true, error);
    if (this.responseCounter === this.table.length) {
      this.getDataFromApi(this.getFailedEmailsEndPoint, { atcId: this.atcSelected }).subscribe(
        this.getFailedEmailsSuccessHandler.bind(this),
        this.handleSubscriptionError.bind(this, this.onSendBtnClick.bind(this, this.atc), false)
        );
        this.resetAddedEmails();
    }
  }


  /**
   * Failure handler for sendEmailInvite.
   * @param failedEmail candidate whose email failed.
   */
  handleEmailError(failedEmail: CandidateModel) {
    this.responseCounter++;
    this.failed++;
    this.emailsFailed.push(failedEmail);
    this.emailsSent++;

    this.modalData.title = this.failed === 1 ? this.failed + ' Email Failed' : this.failed + ' Emails Failed';
    this.sendNextEmail();
    if (this.responseCounter === this.table.length) {
      this.getDataFromApi(this.getFailedEmailsEndPoint, { atcId: this.atcSelected }).subscribe(
        this.getFailedEmailsSuccessHandler.bind(this),
        this.handleSubscriptionError.bind(this, this.onSendBtnClick.bind(this, this.atc), false)
        );
        this.resetAddedEmails();
    }
  }

  /**
   * Sends email to the next candidate.
   */
  sendNextEmail() {
    if (++this.emailListIndex < this.table.length) {
      this.sendEmailInvite();
    }
  }
  removeDash(value): string {
    if (value === '-') {
      value = '';
    }
    return value;
  }

  checkForValidData() {
    for (const row of this.table) {
      for (const cell of row) {
        if (cell.type !== 6 && cell.strClass.indexOf('invalid') !== -1) {
          return false;
        }
      }
    }
    return true;
  }

  addDataInTableRow(value, type) {
    let className = 'table-data';
    let isValid = true;
    if (type === Types.TEXT) {
      isValid = this.isValidName(value);
    } else {
      isValid = this.isValidEmail(value);
    }
    if (!isValid) {
      className += ' invalid';
    }
    return new Table(type, className, value);
  }

  isValidName(name) {
    const textRegex = /\\|\//g;
    if (name.length < 50 && !textRegex.test(name)) {
      return true;
    }
    return false;
  }

  isValidEmail(email) {
    // tslint:disable-next-line:max-line-length
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regex.test(email)) {
      return true;
    }
    return false;
  }



  showValidationPopup(title, bodyText) {
    const dataForDialog = {
      title: title,
      body: bodyText
    };
    this.validationPopup = true;
    this.showDialog(dataForDialog, () => { this.validationPopup = false; });
  }

  resetAddedEmails() {
    this.table = [];
  }

  isValidate(): boolean {
    if (this.validateTextboxLength(this.firstName, true) && this.validateInputChar(this.firstName)) {
      if (this.validateTextboxLength(this.lastName, true) && this.validateInputChar(this.lastName)) {
        if (this.validateEmail(this.emailEdit.text)) {
          return true;
        }
      }
    }
    return false;
  }

  handleFileImport() {
    if (this.importCsvInput.nativeElement.files[0]) {
      this.candidateList = [];
      this.csvHelper.openReadBuffer(this.importCsvInput.nativeElement.files[0], this.addCandidateInfoToTable.bind(this));
      this.importCsvInput.nativeElement.value = '';
    }
  }

  private openInputDialog() {
    this.progressPopup = false;
    this.importCsvInput.nativeElement.click();
  }

  downloadCsvTemplate(link: HTMLLinkElement) {
    link.click();
  }

  onRowRemoveClicked(event) {
    this.table.splice(this.findIndexInTable(event[2].title), 1);
    this.isExtendedTable = this.table.length > 4;
  }

  findIndexInTable(val): number {
    for (let i = 0; i < this.table.length; i++) {
      if (this.table[i][2].title === val) {
        return i;
      }
    }
    return -1;
  }
}

export enum ATCTYPE {
  INACTIVE = '0',
  ACTIVE = '1',
  BOTH = '2'
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/email-invite/email-invite.component.ts